<template>
  <v-footer>
    <v-row>
      
        <div>
          &#169;
          {{ new Date().getFullYear() }} —
          <strong>Bodensee Buggy by Max</strong>
        </div>
<v-spacer></v-spacer>
        <div class="text-right">
          <router-link to="terms" class="white--text" style="text-decoration: none;"><strong>Rechtliches</strong></router-link>
          <!--
          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on }">
              <v-text v-on="on"><strong>Rechtliches</strong></v-text>
            </template>

            <v-list>
              <v-list-item v-for="(item, index) in items" :key="index">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          -->

        </div>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    items: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" }
    ]
  })
};
</script>